import { render, staticRenderFns } from "./RoleBasedAccessControlPermissions.vue?vue&type=template&id=6f9fd90c&scoped=true"
import script from "./RoleBasedAccessControlPermissions.vue?vue&type=script&lang=js"
export * from "./RoleBasedAccessControlPermissions.vue?vue&type=script&lang=js"
import style0 from "./RoleBasedAccessControlPermissions.vue?vue&type=style&index=0&id=6f9fd90c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9fd90c",
  null
  
)

export default component.exports